/**
 * Currency used to charge accounts by us.
 * E.g. all our products/add-ons will have prices with one of
 * these currencies.
 */
export enum BillingCurrency {
  USD = 'USD',
  BRL = 'BRL',
}
